import { useCallback, useState } from 'react';
import { findHelpTopicById, type HelpCategory } from './help-center-topics';
import { HelpTopicModal } from './HelpTopicModal';

export type HelpTopicLauncherOptions = {
  /** Conservé pour les appelants. Le clic ouvre toujours la modale de la fiche. */
  managedFormationUrls?: Record<string, string>;
  /** Arborescence courante (API) pour la modale et les liens « Voir aussi ». */
  helpCategories?: readonly HelpCategory[] | null;
};

/**
 * Ouvre la modale de la fiche (titre et description édités dans l’admin).
 * Partagé entre la page d’aide et le chat support.
 */
export function useHelpTopicLauncher(opts?: HelpTopicLauncherOptions) {
  const [selectedTopicId, setSelectedTopicId] = useState<string | null>(null);
  const openingOnboardingPlayer = false;

  const selectedContext = selectedTopicId
    ? findHelpTopicById(selectedTopicId, opts?.helpCategories ?? null)
    : null;

  const openTopic = useCallback((topicId: string) => {
    setSelectedTopicId(topicId);
  }, []);

  const helpTopicModal = (
    <HelpTopicModal
      open={Boolean(selectedContext)}
      onClose={() => setSelectedTopicId(null)}
      category={selectedContext?.category ?? null}
      topic={selectedContext?.topic ?? null}
      onOpenTopic={openTopic}
      lookupCategories={opts?.helpCategories ?? null}
    />
  );

  return {
    openTopic,
    openingOnboardingPlayer,
    helpTopicModal,
  };
}
